import { useState } from 'react';
import useTimeoutFn from 'react-use/lib/useTimeoutFn';

export function useShowHook(milliseconds: number, onShow: () => void) {
    const [isVisible, setVisibility] = useState(false);

    useTimeoutFn(() => {
        setVisibility(true);
        onShow();
    }, milliseconds);

    return isVisible;
}
